<div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-40 w-screen overflow-y-auto" (click)="closed.next(true)">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg" (click)="ignoreParentClick($event)">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>